<template>
  <div class="position-relative w-100">
    <b-form-input
      ref="input_ref"
      :disabled="isDisabled"
      :state="state"
      v-model="query"
      placeholder="Сотрудник"
      autocomplete="off"
      @input="onQueryInput"
      @focus="onFocusIn"
      @blur="onFocusOut"
      @click="isFocus = true"
    />

    <button type="button" class="custom-btn-select" :disabled="isDisabled" @mousedown.prevent="onClick">
      <v-icon v-if="query" name="buttons/cross" :size="11"/>
      <v-icon v-else-if="isFocus" name="buttons/collapse_chevrons_down" :size="10"/>
      <v-icon v-else name="buttons/collapse_chevrons_right" :size="10"/>
    </button>

    <div v-if="isFocus" class="custom-dropdown-select">
      <div class="custom-dropdown-list-scroll">
        <div
          v-for="item in filteredItems"
          :key="item.id"
          class="custom-dropdown-select-item"
          @mousedown.prevent="onSelect(item)"
        >
          <div class="text-small">{{ item.name }}</div>
          <div class="text-secondary text-small">{{item.role_name}}</div>
        </div>
      </div>

      <div v-if="filteredItems.length === 0 && query" class="empty-state-container p-2">
        <v-icon name="navbar/empty_table" :size="45"/>
        <small class="text-muted">Ничего не найдено</small>
      </div>
    </div>
  </div>
</template>

<script>
import users from "../../network/users";

export default {
  name: "UserSelect",
  mixins: [ users ],
  props: {
    isDisabled: { type: Boolean, default: null },
    state: { type: Boolean, default: null },
    value: { type: Number, default: null },
  },
  data() {
    return {
      isFocus: false,
      query: '',
      items: [],
      selectedItem: null,
      location_id: 0,
      location_position: null,
      configureRequestId: 0,
      searchRequestId: 0,
      searchTimer: null,
    }
  },
  mounted() {
    this.getItems();
  },
  beforeDestroy() {
    clearTimeout(this.searchTimer);
  },
  computed: {
    filteredItems() {
      if (!this.items || this.items.length === 0) return [];

      const query = this.query ? this.query.trim().toLowerCase() : '';

      if (!query) return this.items;

      if (this.selectedItem && this.selectedItem.name.toLowerCase() === query) {
        return this.items;
      }

      return this.items.filter(item => item.name.toLowerCase().includes(query));
    }
  },
  watch: {
    value: {
      handler(newValue) {
        this.configure(newValue, this.location_id, this.location_position);
      },
      immediate: true
    },
    query: {
      handler(newValue) {
        if (newValue === '' && this.value !== 0 && this.value !== null) {
          this.selectedItem = null;
          this.$emit('onSelect', 0, '');
        }
      },
    },
  },
  methods: {
    async configure(id, locationId, locationPosition) {
      const requestId = ++this.configureRequestId;

      if (locationId !== undefined && locationId !== null) this.location_id = locationId;

      if (locationPosition !== undefined) this.location_position = locationPosition;

      if (id > 0) {
        let user = this.items.find(item => item.id === id);

        if (!user) {
          const result = await this.getUserById(id);

          if (requestId !== this.configureRequestId) return;

          user = (result && result.data) ? result.data : null;
        }

        if (user) {
          this.query = user.name;
          this.selectedItem = user;
        } else {
          this.query = '';
          this.selectedItem = null;
        }
      } else {
        this.query = '';
        this.selectedItem = null;
      }
    },
    onFocusIn() {
      this.isFocus = true;
      const query = this.selectedItem && this.query === this.selectedItem.name ? '' : this.query;
      this.getItems(query);
    },
    onFocusOut() {
      this.isFocus = false;

      if (this.selectedItem) {
        if (this.query !== this.selectedItem.name) {
          this.query = this.selectedItem.name;
        }
      } else {
        this.query = '';
      }
    },
    onClear() {
      clearTimeout(this.searchTimer);
      this.query = "";
      this.selectedItem = null;
      this.getItems();
      this.$emit('onSelect',0);
    },
    onClick() {
      if (this.query) {
        this.onClear();
        this.$refs.input_ref.$el.focus();
      } else {
        this.onFocusIn();
        this.$refs.input_ref.$el.focus();
      }
    },
    onSelect(item) {
      clearTimeout(this.searchTimer);
      this.query = item.name;
      this.selectedItem = item;
      this.$emit('onSelect',item.id, item.name);
      this.onFocusOut();
    },
    async getItems(query = '') {
      const requestId = ++this.searchRequestId;
      const data = {
        page: 1,
        size: 400,
        query: query.trim(),
        locationId: this.location_id,
        locationPositionId: this.location_position,
      }
      const result = await this.getUsersSearch(data);

      if (requestId !== this.searchRequestId) return;

      this.items = (result && result.data) ? result.data.items : [];
    },
    onQueryInput(query) {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => this.getItems(query), 250);
    }
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Users/UserSelect.vue